export type METHOD = "GET" | "POST" | "PUT" | "DELETE";

const HEADERS = {
    Accept: "application/json",
    "Content-Type": "application/json; charset=utf-8",
};

export type QueryParamType = { [key: string]: string | any | number | null };

type callApiArgs = {
    url: string;
    method: METHOD;
    headers?: {};
    body?:
        | {
              [key: string]:
                  | null
                  | string
                  | number
                  | boolean
                  | number[]
                  | string[]
                  | undefined
                  | {}[]
                  | {};
          }
        | FormData;
    queryParams?: QueryParamType;
    downloadFile?: boolean;
    isHeaderInclude?: boolean;
};

const callAPIFromClient = (args: callApiArgs) => {
    const {
        url,
        method,
        headers,
        body,
        queryParams,
        downloadFile,
        isHeaderInclude = false,
    } = args;

    const queryString = queryParams
        ? `?${Object.entries(queryParams)
              .map(([key, value]) => `${key}=${value}`)
              .join("&")}`
        : "";

    const urlWithQueryParams = url + queryString;
    // added ? operator to handle the SSR scenario where document is not defined

    let options: any = {
        method,
        headers: {
            ...HEADERS,
        },
    };

    if (isHeaderInclude) {
        options = {
            ...options,
            credentials: "include",
        };
    }

    if (headers) {
        options.headers = {
            ...options.headers,
            ...headers,
        };
    }

    if (localStorage.getItem("clientId") && isHeaderInclude) {
        options.headers["x-client-id"] = localStorage.getItem("clientId");
    }

    if (body) {
        options.body = JSON.stringify(body);
    }

    return fetch(urlWithQueryParams, options).then(
        (response) => {
            const clientId = response.headers.get("x-client-id");
            if (clientId && isHeaderInclude) {
                localStorage.setItem("clientId", clientId);
            }
            return downloadFile ? response : response.json();
        },
        (err) => console.error("err", err),
    );
};

export default callAPIFromClient;
